// extracted by mini-css-extract-plugin
export default {"container":"TermsAndConditions_container__j+Ct4","termsContent":"TermsAndConditions_termsContent__ba07v","print":"TermsAndConditions_print__RDwgn"};